module.exports = __webpack_public_path__ + "static/img/111.203.13.123.6ee3e2ef.png";